import { getMockStore, updateMockStore } from '../lib/mockStore';
import type { FeaturedContent } from '../types/featured';

export async function getFeaturedContent(): Promise<FeaturedContent> {
  const data = await getMockStore();
  return data.featured;
}

export async function saveFeaturedContent(featured: FeaturedContent): Promise<FeaturedContent> {
  const data = await updateMockStore((draft) => {
    draft.featured = featured;
  });
  return data.featured;
}
